import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    companyFilterContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '80px 0px 0px',
        gap: 30,
        [theme.breakpoints.down('sm')]: {
            padding: '40px 0px'
        }
    },
    companyFilterText: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 10,
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            maxWidth: 325
        }
    },
    companyFilterTitle: {
        fontSize: 40,
        lineHeight: '56px',
        fontFamily: 'GreedWide-Heavy',
        textTransform: 'uppercase',
        justifyContent: 'center',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: 32,
            lineHeight: '40px'
        }
    },
    companyFilterDescription: {
        lineHeight: '18px',
        [theme.breakpoints.down('sm')]: {
            fontSize: 16
        }
    },
    companyFilterBox: {
        scrollSnapAlign: 'center'
    },
    chips: {
        display: 'flex',
        gap: 4
    },
    chip: {
        padding: '6px 40px'
    },
    paper: {
        display: 'flex',
        gap: 4,
        padding: 2,
        marginTop: 24,
        marginBottom: 24,
        overflow: 'scroll',
        scrollbarWidth: 'none',
        [theme.breakpoints.down('sm')]: {
            marginTop: 10,
            marginBottom: 20,
            maskImage: 'linear-gradient(to right, black 85%, transparent 100%)'
        }
    },
    active: {
        color: 'white',
        backgroundColor: 'var(--background-purple) !important'
    }
}))
